/**
 * First show failed simulations
 * Then  simulations without status
 * Last success simulations
 * @param simulations {{pass_expections?:boolean}[]}
 */
export default function sortSimulationsByExceptions(simulations){
  return simulations.sort((a, b) => {

    // the equal
    if (a.pass_expections === b.pass_expections) return 0

    // one pass second fail or not tested
    if (a.pass_expections && !b.pass_expections) return 1
    if (!a.pass_expections && b.pass_expections === true) return -1

    // two false. on failed. one not tested. show first the failed
    if (!a.pass_expections && b.pass_expections === false) return 1 // first B
    if (a.pass_expections === false && !b.pass_expections) return -1 // first a      
  })
}